// client/src/api/companyApi.js
import axios from 'axios';


// const API_URL = '/api/auth';


// Register a new company and user
const registerCompany = async (formData, config) => {
  try {
    // Log the form data being sent (excluding files for security)
    const formDataObj = {};
    for (let [key, value] of formData.entries()) {
      formDataObj[key] = value;
    }
    //console.log('Sending form data:', formDataObj);

    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await axios.post(`/api/companies`, formData, {
      ...config,
      // Add this to see more detailed error messages
      validateStatus: function (status) {
        return status < 500; // Reject only if the status code is greater than or equal to 500
      }
    });

    if (response.data && response.data.token) {
      localStorage.setItem('token', response.data.token);
    }

    return response.data;
  } catch (error) {
    console.error('Registration error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      statusText: error.response?.statusText,
      headers: error.response?.headers,
      config: error.config
    });

    // Throw the full error response if available
    throw error.response?.data || { message: error.message };
  }
};

// Get company profile
const getCompanyProfile = async (companyId) => {
  try {
    // console.log('Fetching company with ID:', companyId);
    const response = await axios.get(`/api/companies/${companyId}`);
    // console.log('API Response:', response.data);
    
    // Backend returns { success: true, data: company }
    // Extract the company data properly
    if (response.data.success) {
      return response.data.data; // Return the company object directly
    }
    return response.data;
  } catch (error) {
    console.error('Error fetching company profile:', error);
    throw error.response?.data || error.message;
  }
};

// Update company profile
const updateCompanyProfile = async (companyId, formData) => {
  try {
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary. Overriding it here
    // causes the server to fail parsing the request ("Unexpected end of form").
    const response = await axios.put(`/api/companies/${companyId}`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export default {
  registerCompany,
  getCompanyProfile,
  updateCompanyProfile
};